import { FcGoogle } from "react-icons/fc";

export default function GoogleSignInButton({ onGoogleSignIn }){

  return(
    <button onClick={onGoogleSignIn} className="flex items-center !border border-blue-200 gap-2 bg-white text-blue-700 px-4 py-2 !rounded-lg hover:shadow-sm">
        <FcGoogle size={24} />
        Login / Sign Up with Google
    </button>
  )

}
